export const TYPOGRAPHY_VARIANTS = {
  primary: "primary",
  secondary: "secondary",
  light: "light",
  italic: "italic",
} as const;

export type TypographyVariants =
  (typeof TYPOGRAPHY_VARIANTS)[keyof typeof TYPOGRAPHY_VARIANTS];
